import React, { useEffect } from 'react';
import { initHeader, selectService, HeaderInfoMenuItem } from './initHeader';

let initialized = false;

export const Header: React.FC<{
  serviceKey?: string;
  infoMenuItems?: HeaderInfoMenuItem[];
}> = ({ serviceKey = 'crhub', infoMenuItems }) => {
  useEffect(() => {
    if (!initialized) {
      initialized = true;
      initHeader({ key: serviceKey, infoMenuItems });
    }
  }, [serviceKey, infoMenuItems]);

  useEffect(() => {
    selectService(serviceKey);
  }, [serviceKey]);

  return null;
};
